module.exports = __webpack_public_path__ + "img/code.01e26457.png";